import React from 'react';
import {Container, Grid, Typography} from "@mui/material";
import NeutralButton from "../../../atoms/NeutralButton";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import colorPalette from "../../../../styles/theme/colorPalette";
import LinkButton from "../../../atoms/LinkButton";
import {css} from "@emotion/react";
import { isMobile } from "react-device-detect";

const HowToOrder = () => {
  return (
      <Container>
        <div css={wrapper}>
          <Grid container alignItems={'center'} justifyContent={'center'}>
            <Grid item xs={12} lg={7}>
              <div css={textWrapper}>
                <div css={text}>
                  <Typography><span>栄養士に相談・ご注文はこちら</span></Typography>
                </div>
                <div>
                  <div css={phone}>
                    {
                      isMobile &&
                          <span>0570-054-014</span>
                        ||
                          <span>0120-054-014</span>
                    }
                    
                  </div>
                  <div css={operationHour}>
                    <span>営業時間：</span>
                    <span>平日9時~17時30分</span>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} lg={5}>
              <div css={btnWrapper}>
                <LinkButton
                    text={'栄養士におまかせして注文'}
                    href={'/teiki'}
                    maxWidth={"300px"}
                    hexColorCode={colorPalette.primary}
                    endAdornment={ <ArrowRightIcon /> }
                    css={btnColor}
                    minWidth={200}
                />
                <LinkButton
                    text={'商品を選んでWEBから注文'}
                    href={'/items'}
                    maxWidth={"300px"}
                    hexColorCode={colorPalette.primary}
                    endAdornment={ <ArrowRightIcon /> }
                    css={btnColor}
                    minWidth={200}
                />
              </div>
            </Grid>
          </Grid>
        </div>
      </Container>
  );
};

export default HowToOrder;

const wrapper = css`
  background: ${colorPalette.primaryGradient.rgb};
  background: ${colorPalette.primaryGradient.gradient};
  margin: 16px 0;
  border-radius: 4px;
  padding: 8px;
  //display: flex;
  //align-items: center;
  //flex-direction: column;
`

const textWrapper = css`
  background-color: white;
  width: 100%;
  border-radius: 8px;
  padding: 1.5rem 0;
`


const text = css`
  text-align: center;
  border-bottom: dashed 1px ${colorPalette.gray};
  padding-bottom: 1rem;
`

const phone = css`
  text-align: center;
  font-size: 4rem;
  font-weight: bold;
  line-height: 1.2;
  padding-top: 1rem;
`

const operationHour = css`
  text-align: center;
  font-weight: 500;
`

const btnWrapper = css`
  padding: 5px 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const btnColor = css`
  background-color: white;
  margin: 5px auto;
`